import { useEffect, useState } from 'react';

const useModalFocus = ({ active, ignore = false, ref }) => {
  const [previousFocusEl, setPreviousFocusEl] = useState(null);

  useEffect(() => {
    const currentRef = ref.current;

    // Set it and forget it
    if (!previousFocusEl) {
      setPreviousFocusEl(document.activeElement);
    }

    // Timeout ensures our state updates before changing focus
    if (active && !ignore) {
      setTimeout(() => {
        currentRef.focus();
      });
    }

    if (active) {
      return () => previousFocusEl?.focus();
    }
  }, [ref, previousFocusEl, active, ignore]);
};

export default useModalFocus;
